/* eslint-disable consistent-return */
/* eslint-disable no-param-reassign */
import Moment from 'moment'
import Timezone from 'moment-timezone'
import axios from 'axios'

import { formatYearAndWeek } from '../../../services/utils'

// ACTIONS
export const SET_DATES = 'SET_DATES'
export const SET_INVITES = 'SET_INVITES'
export const INITIAL_SET_DATES = 'INITIAL_SET_DATES'
export const SET_WEEK = 'SET_WEEK'
export const JOIN_SESSION = 'JOIN_SESSION'
export const JOIN_ERROR = 'JOIN_ERROR'
export const JOINING = 'JOINING'
export const CLEAR_JOIN_ERROR = 'CLEAR_JOIN_ERROR'
export const LEAVE_SESSION = 'LEAVE_SESSION'
export const AUTH_ERROR = 'AUTH_ERROR'

const limit = 100

const formatSession = session => {
  const start = Timezone.tz(session.start_time, session.timezone)
  const end = Timezone.tz(session.end_time, session.timezone)

  const dateString = start.format('dddd, MMMM Do YYYY')
  const week = formatYearAndWeek(start)

  const startTime = start.format('h:mmA')
  const endTime = end.format('h:mmA')

  const participant_ids = session.participants.map(participant => participant.id)

  return {
    ...session,
    participant_ids,
    dateString,
    week,
    length: {
      duration: `${startTime}-${endTime}`,
      timezone: `(${Timezone.tz(session.timezone).format('zz')})`
    },
    location_string: `${session.location} - ${session.room}`,
    dial_in: session.dial_in ? 'Yes' : 'No'
  }
}

export function getInitialDates(offset = 0, campaignId, filtered = true) {
  return (dispatch, getState) => {
    const options = getState()
      .get('scheduling')
      .get('options')
      .toJSON()

    campaignId = campaignId || options.campaignId
    const token =
      options.token ||
      getState()
        .get('engagement')
        .auth.get('JWT')

    return axios({
      method: 'get',
      url: `/hackersmindcampaigns/${campaignId}/scheduled_sessions/?limit=${limit}&offset=${offset}&filtered=${filtered}`,
      headers: {
        Authorization: `${token}`
      }
    })
      .then(res => {
        if (res.status === 200) {
          const sessions = res.data
            .map(session => formatSession(session))
            .sort((a, b) => Moment(a.start_time).diff(Moment(b.start_time)))

          const first = sessions.length ? sessions[0].week : formatYearAndWeek(Moment(Date.now()))
          const last = sessions.length ? sessions[sessions.length - 1].week : '1975-01'

          if (offset === 0) {
            dispatch({
              type: SET_WEEK,
              data: first
            })
          }
          dispatch({
            type: INITIAL_SET_DATES,
            data: {
              sessions,
              offset: offset + 100,
              last_week: last,
              finished: res.data.length !== limit
            }
          })
        }
      })
      .catch(err => {
        dispatch(authError(err))
      })
  }
}

export function getDates(offset = 0, campaignId, filtered = true) {
  return (dispatch, getState) => {
    const options = getState()
      .get('scheduling')
      .get('options')
      .toJSON()

    campaignId = campaignId || options.campaignId
    const token =
      options.token ||
      getState()
        .get('engagement')
        .auth.get('JWT')

    return axios({
      method: 'get',
      url: `/hackersmindcampaigns/${campaignId}/scheduled_sessions/?limit=${limit}&offset=${offset}&filtered=${filtered}`,
      headers: {
        Authorization: `${token}`
      }
    })
      .then(res => {
        if (res.status === 200) {
          const sessions = res.data
            .map(session => formatSession(session))
            .sort((a, b) => Moment(a.start_time).diff(Moment(b.start_time)))

          const first = sessions.length ? sessions[0].week : formatYearAndWeek(Moment(Date.now()))
          const last = sessions.length ? sessions[sessions.length - 1].week : '1975-01'

          if (offset === 0) {
            dispatch({
              type: SET_WEEK,
              data: first
            })
          }
          dispatch({
            type: SET_DATES,
            data: {
              sessions,
              offset: offset + 100,
              last_week: last || '1975-01',
              finished: res.data.length !== limit
            }
          })
        }
      })
      .catch(err => {
        dispatch(authError(err))
      })
  }
}

export function authError(err) {
  return dispatch => {
    dispatch({
      type: AUTH_ERROR,
      data: err.response.data
    })
  }
}

export function nextWeek(campaignId, filtered) {
  return (dispatch, getState) => {
    const sessions = getState()
      .get('scheduling')
      .get('sessions')
      .toJSON()
    const { week, last_week, finished, offset } = sessions

    const next_week = formatYearAndWeek(Moment(week, 'YYYY-WW').add(1, 'week'))

    if (next_week === last_week && !finished) dispatch(getDates(offset, campaignId, filtered))

    dispatch({
      type: SET_WEEK,
      data: next_week
    })
  }
}

export function prevWeek() {
  return (dispatch, getState) => {
    const week = getState()
      .get('scheduling')
      .get('sessions')
      .get('week')

    dispatch({
      type: SET_WEEK,
      data: formatYearAndWeek(Moment(week, 'YYYY-WW').subtract(1, 'week'))
    })
  }
}

export function currentWeek() {
  return dispatch => {
    dispatch({
      type: SET_WEEK,
      data: formatYearAndWeek(Moment())
    })
  }
}

export function joinSession(sessionId) {
  return (dispatch, getState) => {
    const joined = getState()
      .get('scheduling')
      .get('sessions')
      .get('joined')
    const options = getState()
      .get('scheduling')
      .get('options')
      .toJSON()
    const { employee, token } = options

    if (joined) return

    dispatch({
      type: JOINING,
      data: true
    })

    return axios({
      method: 'get',
      url: `/hackersmindscheduledsessions/${sessionId}/join/`,
      headers: {
        Authorization: `${token}`
      }
    })
      .then(res => {
        if (res.status === 200) {
          dispatch({
            type: JOIN_SESSION,
            data: formatSession(res.data.session, employee)
          })

          dispatch({
            type: SET_INVITES,
            data: res.data.invites
          })
        }

        dispatch({
          type: JOINING,
          data: false
        })
      })
      .catch(({ response, message }) => {
        if (response) {
          switch (response.status) {
            case 400:
              dispatch({
                type: JOIN_ERROR,
                data: {
                  code: response.status,
                  data: response.data,
                  message: response.data.Error,
                  ...options
                }
              })
              break
            case 500:
              dispatch({
                type: JOIN_ERROR,
                data: {
                  code: response.status,
                  data: response.data,
                  message:
                    'Join failed! An error occured while trying to join the selected campaign.<br />Please refresh the page and try again, if the problem persists contact our support team.',
                  ...options
                }
              })
              break
            default:
              // eslint-disable-next-line  no-console
              console.error('Unknown Error', message)
              break
          }
        } else {
          // eslint-disable-next-line  no-console
          console.error('Unknown Error', message)
        }
      })
  }
}

export function leaveSession(sessionId) {
  return (dispatch, getState) => {
    const options = getState()
      .get('scheduling')
      .get('options')
      .toJSON()
    const { employee, token } = options

    return axios({
      method: 'get',
      url: `/hackersmindscheduledsessions/${sessionId}/leave/`,
      headers: {
        Authorization: `${token}`
      }
    }).then(res => {
      if (res.status === 200) {
        dispatch({
          type: LEAVE_SESSION,
          data: formatSession(res.data, employee)
        })
      }
    })
  }
}
